module.exports = __webpack_public_path__ + "static/media/EasyMealPlannerPic.aaf283c3.png";